import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'button[ui-button], button[ui-icon-button], button[ui-fab-button]',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIButtonComponent {
  readonly color = input<string>();

  @HostBinding('attr.color')
  get colorAttribute() {
    return this.color();
  }
}
